// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1CVjR","itemTitle":"ClientEmergencyInfo_itemTitle__1oN3F","itemText":"ClientEmergencyInfo_itemText__1nj8a"};